/**
 * @file 混入
 * @author hardylin <hardylin@tencent.com>
 */
import config from './config'

export default {

    methods: {

        /**
         * 返回规范颜色值
         * @param {Number} index - 配色规范色号
         * @param {Number} [opacity = 1] - 透明度
         */
        mColor(index, opacity = 1) {
            const color = Object.assign({}, config.colors, this.colors)
            if (Number.isInteger(index)) {
                return color[index]
            } else {
                index = index.toString()
                switch (index) {
                    case '2.1':
                        opacity = 0.65
                        break
                    case '3.1':
                        opacity = 0.5
                        break
                    case '8.1':
                        opacity = 0.6
                        break
                    case '8.2':
                        opacity = 0.3
                        break
                    case '15.1':
                        opacity = 0.8
                        break
                }
                let str = color[index.split('.')[0]]
                return str.includes('#') ? `rgba(${ Number.parseInt(str.substr(1, 2), 16) }, ${ Number.parseInt(str.substr(3, 2), 16) }, ${ Number.parseInt(str.substr(5, 2), 16) }, ${ opacity })` : str.replace('1)', opacity + ')')
            }
        },
    }
}